import * as React from 'react';
var DirectionContext = /*#__PURE__*/React.createContext({
  isRTL: false,
  locale: 'en-US'
});
export default DirectionContext;